import { z } from "zod";

import {
  defaultFalseSchema,
  defaultEmptyStringSchema,
  defaultZeroSchema,
} from "./primitives";
import { catFormDataSchema } from "./cat-form-data.schema";
import { userFormDataSchema } from "./user-form-data.schema";
import { deliveryDataSchema } from "./delivery-data.schema";
import { subscriptionDataSchema } from "./subscription-data.schema";
import { viewStateSchema } from "./view-state.schema";
import { clearNibblesForIneligibleCats } from "../helpers/nibbles-allergy-gate";
import { prefillMissingPreferences } from "../helpers/preference-defaults";

export const signupFlowStoreSchema = z
  .object({
    isStoreInitialised: defaultFalseSchema,
    versionMismatchDetected: defaultFalseSchema,
    featureFlags: z
      .record(z.string(), z.union([ z.string(), z.boolean() ]))
      .default({})
      .catch({}),
    cats: z.record(z.string(), catFormDataSchema).default({}),
    activeCatId: defaultEmptyStringSchema,
    user: z.preprocess((val) => val ?? {}, userFormDataSchema),
    delivery: z.preprocess((val) => val ?? {}, deliveryDataSchema),
    subscription: z.preprocess((val) => val ?? {}, subscriptionDataSchema),
    viewState: z.preprocess((val) => val ?? {}, viewStateSchema),
    isLoading: defaultFalseSchema,
    sufQuizVersion: defaultZeroSchema,
    savedAt: z.string().optional(),
  })
  .strip()
  .transform(clearNibblesForIneligibleCats)
  .transform(prefillMissingPreferences);

/* Persisted / validated signup-flow snapshot (post-parse, all defaults applied). */
export type TSignupFlowStoreData = z.infer<typeof signupFlowStoreSchema>;

/* Pre-parse shape: matches what the runtime store holds before hydration. */
export type TSignupFlowStoreInput = z.input<typeof signupFlowStoreSchema>;

/* Validates and normalises rehydrated signup-flow snapshots. */
export function parseSignupFlowPersistedSnapshot(raw: unknown) {
  return signupFlowStoreSchema.safeParse(raw);
}
